import React, { useEffect, useState } from "react";
import ReactQuill from "react-quill-new";
import { useDispatch, useSelector } from "react-redux";
import Swal from "sweetalert2";
import { updateEmailTemplate } from "../Redux/Reducers/ProductSlice";

const decodeTemplateVariables = (body = "") =>
  body.replace(/-&(?:amp;)?gt;/g, "->");

const formatTemplateBody = (body = "") =>
  decodeTemplateVariables(body.replace(/\\n/g, "").replace(/\\"/g, '"'));

const removeNewLinesFromBody = (body = "") =>
  body.replace(/\\n/g, "").replace(/[\r\n]/g, "");

const formatTemplateBodyForSubmit = (body = "") =>
  decodeTemplateVariables(removeNewLinesFromBody(body));

const EmailTemplateForm = ({ template, onBack }) => {
  const dispatch = useDispatch();
  const { submitting } = useSelector((state) => state.products);
  const [formData, setFormData] = useState({
    name: "",
    subject: "",
    message: "",
  });
  const [initialFormData, setInitialFormData] = useState({
    name: "",
    subject: "",
    message: "",
  });

  useEffect(() => {
    if (template) {
      const nextFormData = {
        name: template.name || "",
        subject: template.subject || "",
        message: formatTemplateBody(template.body || ""),
      };

      setFormData(nextFormData);
      setInitialFormData(nextFormData);
    }
  }, [template]);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

  const isChanged =
    formData.name !== initialFormData.name ||
    formData.subject !== initialFormData.subject ||
    formData.message !== initialFormData.message;

  const handleSubmit = async (e) => {
    e.preventDefault();

    try {
      const response = await dispatch(
        updateEmailTemplate({
          key: template.key,
          templateData: {
            name: formData.name,
            subject: formData.subject,
            body: formatTemplateBodyForSubmit(formData.message),
            active: template.active ?? true,
          },
        })
      ).unwrap();

      Swal.fire({
        icon: "success",
        title: "Updated Successfully!",
        text: response?.message || "Email template updated successfully.",
        timer: 2000,
        showConfirmButton: false,
      });

      setInitialFormData(formData);
    } catch (error) {
      Swal.fire({
        icon: "error",
        title: "Update Failed!",
        text:
          error?.message ||
          error?.error ||
          error ||
          "Something went wrong while updating the template.",
      });
    }
  };

  if (!template) {
    return (
      <div className="container mt-4 mainForm free-tape-form text-center py-5">
        <p className="mb-0">Please select an email template to edit.</p>
      </div>
    );
  }

  return (
    <form onSubmit={handleSubmit} className="container mt-4 mainForm free-tape-form">
      <div className="mb-3">
        <label htmlFor="name" className="form-label">
          Name <span>*</span>
        </label>
        <input
          type="text"
          className="form-control"
          id="name"
          name="name"
          value={formData.name}
          onChange={handleChange}
          required
          placeholder='e.g., "John Doe"'
        />
      </div>

      <div className="mb-3">
        <label htmlFor="subject" className="form-label">
          Subject <span>*</span>
        </label>
        <input
          type="text"
          className="form-control"
          id="subject"
          name="subject"
          value={formData.subject}
          onChange={handleChange}
          required
          placeholder='e.g., "Need Free Tape"'
        />
      </div>

      <div className="mb-3">
        <label htmlFor="message" className="form-label">
          Message <span>*</span>
        </label>
        <div className="free-tape-editor">
          <ReactQuill
            theme="snow"
            value={formData.message}
            onChange={(value) =>
              setFormData((prev) => ({
                ...prev,
                message: value,
              }))
            }
          />
        </div>
      </div>

      <button
        type="submit"
        className="btn btn-primary"
        disabled={!isChanged || submitting}
      >
        {submitting ? "Updating..." : "Update"}
      </button>
    </form>
  );
};

export default EmailTemplateForm;
